import type { AnalysisEnablementOptions } from '@/app/analysis';
import { analysisView } from '@/app/analysis';
import type { ClientContext } from '@/app/clientContext';
import type { MessageId } from '@/assets/lang/en-US';
import type { CustomIconName } from '@/components/Icon/Icon';
import { GroupAnalysisType } from '@/generated/types/navigator/types.gen';
import type { ClientTerminology } from '@/views/list/NetworkTerms';

export interface ObjectiveOption {
  label: string;
  value: GroupAnalysisType;
  url?: string;
  description: string;
  icon?: CustomIconName;
}

/** Display order for objectives in the dropdown. */
const OBJECTIVE_DISPLAY_ORDER: GroupAnalysisType[] = [
  GroupAnalysisType.PRIORITY,
  GroupAnalysisType.WILDFIRE_PRIORITY,
  GroupAnalysisType.FALL_IN,
  GroupAnalysisType.ENCROACHMENT,
  GroupAnalysisType.WORKLOAD_ANALYSIS,
  GroupAnalysisType.CLEAR,
];

/**
 * Filters and maps analysisView entries into SelectComponent option objects.
 *
 * Only analyses for which isEnabled returns true (given the current client
 * context and feature flags) are included. Labels and descriptions are
 * resolved via intl so the result is locale-aware.
 */
export function buildObjectiveOptions(
  context: ClientContext,
  enablementOptions: AnalysisEnablementOptions,
  intl: Pick<ClientTerminology, 'formatMessage'>
): ObjectiveOption[] {
  return OBJECTIVE_DISPLAY_ORDER.filter((key) =>
    analysisView[key]?.isEnabled(context, enablementOptions)
  ).map(
    (key): ObjectiveOption => ({
      label: intl.formatMessage({
        id: analysisView[key].getLabel(context, enablementOptions),
      }),
      value: key,
      url: analysisView[key].helpLink,
      description: intl.formatMessage({
        id: analysisView[key].description as MessageId,
      }),
      icon: analysisView[key].icon,
    })
  );
}
